import classNames from 'classnames';
import { defaultTo, omit } from 'lodash-es';
import type { InputHTMLAttributes, DetailedHTMLProps, PropsWithChildren, Ref } from 'react';
import { sanitizeNumber, sanitizeString } from './form-utils';

type InputProps<T> = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  onValueChange?: (value: T | undefined) => void;
  inputRef?: Ref<HTMLInputElement> | null;
};

function Input<T = string>(props: PropsWithChildren<InputProps<T>>) {
  return (
    <input
      ref={props.inputRef}
      {...omit(props, 'value', 'onValueChange', 'inputRef')}
      value={defaultTo(props.value, '')}
      className={classNames(
        'block h-10 w-full px-3 py-2 text-sm focus:outline-none ',
        props.className,
        {
          'border border-light focus:border-medium rounded-lg': !props.readOnly,
          'bg-contrast text-dark hover:border-primary-light-shade': !props.disabled,
          'bg-light text-medium': props.disabled,
          'bg-transparent px-0': props.readOnly,
        },
      )}
    />
  );
}

type InputTextLegacyProps = InputProps<string>;
export const InputTextLegacy = (props: InputTextLegacyProps) => <Input type="text" onChange={event => props.onValueChange?.(sanitizeString(event.target.value))} {...props} />;

type InputNumberLegacyProps = InputProps<number>;
export const InputNumberLegacy = (props: InputNumberLegacyProps) => <Input type="number" onChange={event => props.onValueChange?.(sanitizeNumber(event.target.valueAsNumber))} {...props} />;

type InputEmailLegacyProps = InputProps<string>;
export const InputEmailLegacy = (props: InputEmailLegacyProps) => <Input type="email" onChange={event => props.onValueChange?.(sanitizeString(event.target.value))} {...props} />;

type InputDateLegacyProps = InputProps<string>;
export const InputDateLegacy = (props: InputDateLegacyProps) => <Input type="date" onChange={event => props.onValueChange?.(sanitizeString(event.target.value))} {...props} />;
